import { render, staticRenderFns } from "./salary-checkdata.vue?vue&type=template&id=76dac849&scoped=true&"
import script from "./salary-checkdata.vue?vue&type=script&lang=js&"
export * from "./salary-checkdata.vue?vue&type=script&lang=js&"
import style0 from "./salary-checkdata.vue?vue&type=style&index=0&id=76dac849&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dac849",
  null
  
)

export default component.exports